import {MenuBarView} from '@gongxigames/framework/slot/modules/menubar/MenuBarView';
import {MenuBarViewMobileLandscape} from '@gongxigames/framework/slot/modules/menubar/MenuBarViewMobileLandscape';
import {MenuBarViewMobilePortrait} from '@gongxigames/framework/slot/modules/menubar/MenuBarViewMobilePortrait';
import {IMenuBar, MenuBarButtonConfig} from '@gongxigames/framework/slot/modules/menubar/IMenuBar';
import {DefaultEventsMap, DeviceType} from '@gongxigames/framework/core';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {ScreenOrientedView} from '@gongxigames/framework/slot/fragments/module/view';

export class MenuBarViewMobile extends ScreenOrientedView<DefaultEventsMap, MenuBarView> implements IMenuBar {
    public static readonly NAME: symbol = Symbol('MenuBarViewMobile');
    public static layer = LAYERS.SYSTEM_POPUPS;
    public static platform: DeviceType = DeviceType.MOBILE;

    protected landscapeViewName: symbol = MenuBarViewMobileLandscape.NAME;
    protected portraitViewName: symbol = MenuBarViewMobilePortrait.NAME;

    public updateButtonPanel(config: MenuBarButtonConfig): void {
        this.forEachViews(view => view.updateButtonPanel(config));
    }
}
